// MYUS gallery interactions

document.addEventListener('DOMContentLoaded', function () {

  // --- PDP detail accordions ---
  document.querySelectorAll('.pdp-detail-section').forEach(function (section) {
    var label = section.querySelector('.pdp-detail-label');
    if (!label) return;
    label.addEventListener('click', function () {
      section.classList.toggle('is-open');
    });
  });

  // --- Look grid: inject "Look N" labels + link each image to its detail page ---
  document.querySelectorAll('.image-grid').forEach(function (grid) {

    // Derive the collection slug from the current page filename
    var slug = window.location.pathname
      .split('/').pop()
      .replace('-looks.html', '');

    grid.querySelectorAll('img').forEach(function (img, i) {
      // Wrap in figure
      var fig = document.createElement('figure');
      img.parentNode.insertBefore(fig, img);
      fig.appendChild(img);

      // Look label
      var cap = document.createElement('figcaption');
      cap.textContent = 'Look ' + (i + 1);
      fig.appendChild(cap);

      // Link image to detail page
      img.style.cursor = 'pointer';
      img.addEventListener('click', function () {
        window.location.href = slug + '-look-' + (i + 1) + '.html';
      });
    });
  });

});
